import type { ModelMessages } from '../de/model.js';
import { report } from './report.js';

export const model: ModelMessages = {
  report,
  libraryCategories: {
    people: 'People',
    vehicles: 'Vehicles',
    storage: 'Storage',
    machines: 'Machines',
    office: 'Office',
    social: 'Break rooms & sanitary',
    outdoor: 'Outdoor',
    misc: 'Miscellaneous',
  },
  libraryGroups: {
    sweptPaths: 'Swept paths',
    racks: 'Racks',
    loadCarriers: 'Load carriers & goods',
    cabinets: 'Cabinets',
    shipping: 'Shipping',
    handling: 'Material handling',
    waste: 'Waste',
    machining: 'Machining',
    welding: 'Welding',
    cranes: 'Cranes',
    conveying: 'Conveying',
    workshop: 'Workshop',
    utilities: 'Building services',
    break: 'Break',
    changing: 'Changing rooms',
    sanitary: 'Sanitary',
  },
  library: {
    person: 'Person',
    car: 'Car',
    van: 'Van',
    truck: 'Truck 7.5 t',
    'semi-trailer': 'Articulated lorry',
    'swept-car': 'Swept path car',
    'swept-truck': 'Swept path 7.5 t truck',
    'swept-semi': 'Swept path articulated lorry',
    forklift: 'Forklift',
    pallet: 'Euro pallet',
    'pallet-rack-1825': 'Pallet rack 1,825 mm',
    'pallet-rack': 'Pallet rack 2,700 mm',
    'pallet-rack-3600': 'Pallet rack 3,600 mm',
    'pallet-rack-5560': 'Pallet rack 5,560 mm (LTT special)',
    shelf: 'Shelving unit 3.00 m',
    'shelf-2500': 'Shelving unit 2.50 m',
    'shelf-2000': 'Shelving unit 2.00 m',
    'cantilever-rack': 'Cantilever rack, single-sided',
    'cantilever-rack-double': 'Cantilever rack, double-sided',
    'container-20': 'Container 20 ft',
    machine: 'Machine',
    'cnc-machine': 'CNC machine',
    'welding-table-1x1': 'Welding table 1 × 1 m',
    'welding-table-2x1': 'Welding table 2 × 1 m',
    'welding-station': 'Welding station (booth)',
    'truss-welding-table': 'Truss welding table',
    workbench: 'Workbench',
    'control-cabinet': 'Control cabinet',
    desk: 'Office desk',
    tank: 'Tank',
    'underfloor-saw': 'Underfloor circular saw with roller conveyors',
    'cnc-router': 'CNC wood router (gantry, 3 × 2 m)',
    'jib-crane': 'Pillar jib crane',
    'bridge-crane': 'Bridge crane (overhead crane)',
    'press-brake': 'Press brake',
    'band-saw': 'Metal band saw',
    'drill-press': 'Pillar drill',
    compressor: 'Air compressor with tank',
    'dust-extractor': 'Dust extraction unit with filter',
    'mesh-box': 'Mesh pallet box',
    'pallet-truck': 'Hand pallet truck',
    'flow-rack': 'Flow rack',
    'klt-rack': 'Small parts rack with KLT bins',
    'packing-table': 'Packing table',
    'floor-scale': 'Floor scale',
    'hazmat-cabinet': 'Hazardous materials cabinet',
    'charging-station': 'Forklift charging station',
    'press-container': 'Compactor container',
    'bench-desk': 'Double workstation (bench)',
    'corner-desk': 'Corner desk',
    'office-chair': 'Office chair',
    'file-cabinet': 'Filing cabinet',
    'drawer-pedestal': 'Mobile pedestal',
    'meeting-table': 'Meeting table (6 seats)',
    'meeting-table-4': 'Meeting table (4 seats)',
    'server-rack': 'Server rack 19″ (42 U)',
    'plotter-a0': 'Large-format plotter A0',
    'copy-station': 'Copy station (copying and scanning)',
    'table-group-4': 'Table for four',
    'table-group-8': 'Long table group (8 seats, combinable)',
    kitchenette: 'Kitchenette',
    fridge: 'Fridge',
    'locker-2': 'Locker, 2 doors',
    'locker-3': 'Locker, 3 doors',
    'locker-4': 'Locker, 4 doors',
    'changing-bench': 'Changing room bench',
    shower: 'Shower cubicle',
    'wc-cubicle': 'WC cubicle',
    'wash-trough': 'Wash trough (3 places)',
    urinal: 'Urinal',
    wc: 'Toilet (standing)',
    'washbasin-60': 'Washbasin with mirror 60 cm',
    'gas-tank': 'Shielding gas tank (argon/CO₂)',
    'site-toilet': 'Portable toilet',
    'bike-shelter': 'Bicycle shelter',
    'ev-charger': 'EV charging point',
    'waste-station': 'Waste collection point',
    gatehouse: 'Gatehouse with barrier',
    'skip-wood-7': 'Skip container for wood 7 m³',
    'skip-waste-10': 'Skip container for general waste 10 m³',
    'waste-bin-1100': 'Wheelie bin 1,100 l',
    'tilting-skip': 'Forklift tipping skip',
    'recycling-station': 'Recycling station (3 bins)',
    'shipping-table': 'Shipping table with roll dispenser',
    'alu-tube-bundle': 'Aluminium tube bundle 6 m',
    'pallet-stack-15': 'Stack of euro pallets (15)',
    'steel-cabinet': 'Workshop cabinet with hinged doors',
    'heavy-rack': 'Heavy-duty shelving',
    'wall-jib-crane': 'Wall-mounted jib crane (4 m reach)',
    'work-table': 'Work table 3.0 × 1.2 m',
    'twin-head-welder': 'Twin-head welding machine 7 m',
    'truss-welding-table-partition': 'Truss welding table with partition',
    'roller-conveyor': 'Roller conveyor 3 m',
    'tool-wall': 'Tool pegboard (wall-mounted)',
    'tool-trolley': 'Tool trolley',
    'desk-plain': 'Office desk (no PC)',
    sideboard: 'Sideboard',
    'fire-extinguisher': 'Fire extinguisher with sign',
    'first-aid-station': 'First aid station',
    'emergency-shower': 'Emergency shower with eye wash',
    'welding-screen': 'Welding screen partition 3 × 2 m',
    'pallet-boxes-1x1': 'Pallet with cartons 1 × 1 m (16 pieces)',
    'truss-carton-pallet': 'Pallet with truss cartons (28 pieces)',
    'pallet-carton-1x1': 'Pallet with packed carton 1 × 1 m',
    'pallet-carton-2x1': 'Pallet with packed carton 2 × 1 m',
  },
  openings: {
    'sectional-door': 'Sectional door',
    'rolling-door': 'Industrial roller door',
    'rapid-door': 'High-speed door',
    'fire-gate': 'Fire-rated sliding gate',
    door: 'Door',
    'double-door': 'Double door',
    'glass-door': 'Glass door',
    'glass-double-door': 'Glass double door',
    passage: 'Wall opening (doorway)',
    'double-passage': 'Wide wall opening (doorway)',
    window: 'Window',
    'window-band': 'Ribbon window',
    'loading-dock': 'Truck loading dock',
    void: 'Open wall section',
  },
  zoneCategories: {
    production: 'Production',
    storage: 'Storage',
    'goods-in': 'Goods in',
    'goods-out': 'Goods out',
    assembly: 'Assembly',
    packaging: 'Packaging',
    office: 'Office',
    social: 'Break room',
    technical: 'Technical',
    workshop: 'Workshop',
    'open-space': 'Open space',
    'truck-access': 'Truck access',
    'forklift-path': 'Forklift route',
    walkway: 'Walkway',
    'escape-route': 'Escape route',
    'work-area': 'Work area',
    paving: 'Paved area',
    green: 'Green area',
    gravel: 'Gravel area',
    'crushed-stone': 'Crushed stone area',
    asphalt: 'Asphalt area',
    concrete: 'Concrete area',
    other: 'Other',
  },
  zoneGroups: {
    function: 'Functional areas',
    traffic: 'Traffic areas',
    surface: 'Surfaces and green areas',
  },
  fenceKinds: {
    mesh: 'Welded mesh panels',
    mobile: 'Construction fence (mobile)',
  },
  wallTypes: {
    drywall: 'Drywall 12.5 cm',
    'masonry-115': 'Sand-lime brick 11.5 cm',
    'masonry-175': 'Sand-lime brick 17.5 cm',
    'masonry-24': 'Sand-lime brick 24 cm',
    'concrete-20': 'Concrete 20 cm',
    'concrete-25': 'Concrete 25 cm',
    'brick-24': 'Clinker 24 cm',
    sandwich: 'Sandwich panel 15 cm (vertical)',
    'sandwich-horizontal': 'Sandwich panel 15 cm (horizontal)',
  },
  roomTypes: {
    office: 'Office',
    meeting: 'Meeting room',
    kitchen: 'Kitchen / break',
    'wc-women': 'WC women',
    'wc-men': 'WC men',
    'wc-accessible': 'Accessible WC',
    changing: 'Changing room',
    shower: 'Shower',
    corridor: 'Corridor',
    technical: 'Technical room',
    storage: 'Storage / archive',
    other: 'Room',
  },
  roomTemplates: {
    'corridor-offices': {
      label: 'Corridor with offices',
      hint: 'Corridor 1.50 m along the length, offices approx. 3.60 m wide on both sides (on one side in narrow buildings).',
    },
    social: {
      label: 'Staff facilities',
      hint: 'Corridor 1.50 m along the length, plus WC women/men/accessible, changing rooms, shower and kitchen.',
    },
  },
  roads: {
    road: 'Road',
    'truck-access': 'Truck access',
    'fire-lane': 'Fire brigade access',
    footpath: 'Footpath',
  },
  parkings: {
    car: 'Car park',
    truck: 'Truck parking spaces',
  },
  roofElements: {
    'skylight-dome': 'Skylight dome',
    'skylight-band': 'Rooflight strip',
    'smoke-vent': 'Smoke vent dome',
  },
  stairTypes: {
    straight: 'Straight stairs',
    u: 'Half-turn stairs (U)',
    l: 'Quarter-turn stairs (L)',
  },
  sides: {
    south: 'South wall',
    east: 'East wall',
    north: 'North wall',
    west: 'West wall',
  },
  levels: {
    ground: 'Ground floor',
    upper: 'Floor {n}',
    top: 'Floor {n} (gallery)',
  },
  sectionName: 'Area {letter}',
  warnings: {
    overplanned: 'More area is planned in {name} than is available',
    officeOutsideHall: '{name} is planned as built-in but does not stand entirely inside a hall',
    officeAboveEave: '{name} ({height}) is higher than the eave of {hall} ({eave})',
    officeLowAir: '{name} ({height}) leaves only {air} below the eave of {hall}',
    stair: '{name}: {hint}',
    buildingOutsideSite: '{name} does not lie entirely on the site',
    sitesOverlap: 'Sites overlap – the area would be counted twice',
    overlap: '{a} and {b} overlap',
  },
  dock: {
    steep: 'Ramp at {pct} % is steeper than 10 % – the trailer may hit the wall',
    narrow: 'Dock approach only {width} m wide (at least {min} m)',
    short: 'Standing area of the loading dock only {length} m long (at least {min} m)',
    narrowerThanGate: 'Dock approach is narrower than the gate',
    levelerWider: 'Dock leveller is wider than the gate',
    offSite: 'Dock approach extends beyond the site',
    overlap: 'Two dock approaches overlap – move the gates further apart',
  },
  costs: {
    title: 'Quantities and cost estimate',
    columns: ['Item', 'Quantity', 'Unit price', 'Amount'],
    units: { t: 't', m2: 'm²', m3: 'm³', pcs: 'pcs', kWp: 'kWp' },
    perUnit: { t: '€/t', m2: '€/m²', m3: '€/m³', pcs: '€/pc', kWp: '€/kWp' },
    items: {
      steel: 'Structural steel (assembled)',
      concrete: 'Reinforced concrete: concrete C30/37 (placed)',
      rebar: 'Reinforced concrete: reinforcing steel (fixed)',
      formwork: 'Reinforced concrete: formwork',
      precast: 'Precast concrete (columns, binders, beams, erected)',
      roofSandwich: 'Roof sandwich panels',
      roofFlat: 'Flat roof (deck, insulation, membrane)',
      wallSandwich: 'Wall sandwich panels',
      wallTrapezoid: 'Wall trapezoidal sheet',
      wallMasonry: 'Masonry (sand-lime, plastered)',
      wallBrick: 'Facing brick masonry',
      wallDrywall: 'Drywall partition',
      hallFloor: 'Floor slab / industrial floor',
      mezzanine: 'Mezzanine (steel)',
      gate: 'Sectional / rolling door',
      fireGate: 'Fire-rated sliding gate',
      rapidDoor: 'High-speed door',
      dock: 'Loading dock with leveller',
      door: 'Door',
      doubleDoor: 'Double door',
      window: 'Window / window band (wall)',
      skylight: 'Skylight dome',
      skylightBand: 'Rooflight strip',
      smokeVent: 'Smoke and heat vent',
      pv: 'Rooftop PV system (modules, mounting, inverters, installed)',
    },
    surcharges: {
      foundations: 'Foundations and earthworks',
      services: 'Building services',
      fees: 'Ancillary costs (design, fees)',
    },
    measured: 'Total of measured items',
    surcharge: '{label} ({percent} %)',
    total: 'Total (net)',
    range: 'Range (± {percent} %)',
    notesTitle: 'Assumptions and limits',
    steelDetail:
      'Steel: frames {frame} t, purlins/girts {secondary} t, bracing {bracing} t, columns {columns} t, connections {extra} t',
    concreteDetail:
      'Reinforced concrete: slabs {slab} m³, beams {beam} m³, columns {column} m³, walls {wall} m³, foundations {foundation} m³; reinforcement {rebar} t (usual rates per m³)',
    priceBasis: 'Price basis: catalog “{name}”, with this project’s own prices on top',
    precastDetail:
      'Precast concrete: {volume} m³ of hall columns, binders and beams, with reinforcement and erection',
    replacedPrices:
      'Own prices for floor slabs, concrete walls or concrete columns no longer apply: reinforced concrete is now priced as concrete, reinforcing steel and formwork.',
    notes: [
      'Rough cost estimate from the plan quantities with this project’s unit prices, net of VAT.',
      'Not measured: earthworks, foundations (unless worked out from the columns), building services, external works, fit-out and ancillary costs unless added as a surcharge.',
      'Steel weight, concrete quantities and foundations from the pre-sizing; not a structural analysis or a quote.',
    ],
  },
  collisions: {
    overlap: '{a} overlaps {b}',
    wall: '{a} penetrates a wall',
    lining: '{a} reaches into a drywall lining',
    column: '{a} stands in a column',
    clearance: 'Clearance of {a} is occupied by {b}',
    clearanceWall: 'Clearance of {a} reaches into a wall',
  },
  stairHints: {
    steep: 'Riser above 19 cm – stairs too steep',
    stepRule: 'Step rule {value} cm outside 59–65 cm',
    narrow: 'Flight width below 1.00 m – usually too narrow for an escape route',
    landingNeeded: '{n} risers in one flight – an intermediate landing is needed after 18 at most',
  },
  hallStructure: {
    trussGirder:
      'Steel binder spanning more than {span} m: a truss is usually more economical than a rolled section',
    precastSpan:
      'Prestressed concrete binders over {span} m are unusual – add interior columns or plan in steel',
    steepPrecast:
      'Roof pitch {pitch}°: prestressed pitched binders usually slope 3–5 %; here the underside rises towards the ridge',
  },
  officeStructure: {
    slabThin:
      '{name}: a {thickness} cm slab is too thin for a {span} m span – about {recommended} cm recommended',
    wideSpan:
      '{name}: slabs span {span} m between load-bearing walls – add columns, a beam or a load-bearing inner wall',
    unsupported:
      '{name}: {n} columns on the {level} stand without a column below – a transfer beam is needed',
    hallColumn: '{name}: hall column on axis {axis} stands in the office block',
    hallGableColumn: '{name}: a gable wall column of the hall stands in the office block',
    headroom: '{name}: reaches up to {top} m, the hall structure above already starts at {steel} m',
  },
  plan: {
    unassigned: 'Unassigned',
    terrace: 'Roof terrace',
    roof: 'Roof',
    stairFrom: 'from {level}',
    stairSteps: '{n} risers {riser}/{going}',
    stalls: { one: '{n} parking space', other: '{n} parking spaces' },
    area: 'Area {n}',
    stairwell: 'Stairwell',
    gfaStorey: 'GFA {level} {area} · total {total}',
    netArea: 'Inside {area}',
    officeTitle: '{name} · {n} floors · {info}',
    floors: { one: '{n} floor · {height}', other: '{n} floors · {height}' },
    levelClearHeight: '{level} · clear height {height}',
    gfa: 'GFA {area}',
    eave: 'Eave {height}',
    eaveRidge: 'Eave {eave} · ridge {ridge}',
    roomHeight: '{area} · CH {height}',
  },
  errors: {
    hallLocked: 'The hall is locked',
    shellLocked: 'The shell of “{name}” is protected (release it in the properties first)',
    hallCornersMin: 'A hall needs at least three corners',
    mezzanineOutside: 'The mezzanine must lie completely inside the hall',
    mezzanineHeight:
      'The mezzanine height must be above the slab thickness and at least 2 m below the eaves',
    mezzanineShape: 'The mezzanine needs at least three corners and must not cross itself',
    mezzanineLocked: 'The mezzanine is locked',
    mezzanineNoFreeEdge: 'The mezzanine has no free edge for a stair',
    canopyNoFit: 'The canopy is wider than the wall',
    canopyLocked: 'The canopy is locked',
    wallImageLocked: 'The wall picture is locked',
    officeLocked: 'The office building is locked',
    ownedWall: 'This wall is controlled by its hall or room',
    rectRoomsOnly: 'Only rectangular rooms can be edited',
    noSpace: 'No more space for {type} ({width} m) in this wall',
    rowTooLong: '{n} × {type} do not fit in the wall ({total} m required)',
    gateTooWide: 'The fence is shorter than the gate ({width} m)',
    rowOverlap: 'The row overlaps existing openings – please adjust spacing or quantity',
    stairNeedsOffice: 'Stairs belong to an office building',
    storeyOutlineLevel: 'Only upper floors can have an outline of their own',
    storeyOutlineOutside: 'The floor outline has to lie on the floor below and cover at least 4 m²',
    noUpperLevel: 'There is no further floor above this one',
    stairLocked: 'The stairs are locked',
    lineGone: 'The line no longer exists',
    pointGone: 'The point does not exist',
    segmentGone: 'The section does not exist',
    lineMinPoints: 'A line needs at least two points',
    lineMaxPoints: 'Too many points in one line',
    hallGone: 'The hall does not exist',
    roofNoFit: 'No {type} fits on the roof with these distances',
    polygonMinPoints: 'A polygon needs at least three points',
    socialTooSmall: 'The floor is too small for staff facilities (at least approx. 6 m long)',
    templatesOfficeOnly: 'Room templates are only available for office buildings',
    noInterior: 'This floor has no interior',
    templatesOrthogonal: 'Room templates only work for buildings aligned with the grid',
    levelHasRooms: '{level} already has rooms – please delete them first',
    refSiteGone: 'The reference site no longer exists',
    siteGone: 'The site no longer exists',
    nothingToTakeOver: 'The file contains neither sites nor a background image',
    siteLocked: 'The site is locked',
    noBackground: 'There is no background image',
    backgroundLocked: 'The background image is locked',
    lengthPositive: 'Please enter a length greater than 0',
  },
  commands: {
    moveSelection: 'Move selection',
    rotate: 'Rotate',
    rotateSelection: 'Rotate selection',
    removeSelection: 'Delete selection',
    remove: 'Delete',
    lock: 'Lock',
    unlock: 'Unlock',
    protectShell: 'Protect shell',
    releaseShell: 'Release shell',
    alignObjects: 'Align objects',
    distributeEven: 'Distribute evenly',
    distributeGap: 'Distribute with fixed spacing',
    paste: 'Paste',
    updateProject: 'Change project data',
    updateSettings: 'Change settings',
    addElement: 'Add element',
    updateElement: 'Change element',
    createHall: 'Create hall',
    moveHall: 'Move hall',
    updateHall: 'Change hall',
    resizeHall: 'Change hall size',
    createMezzanine: 'Create mezzanine',
    restoreWalls: 'Restore exterior walls',
    createCanopy: 'Create canopy',
    updateCanopy: 'Change canopy',
    createWallImage: 'Add picture to wall',
    updateWallImage: 'Change wall picture',
    openWall: 'Open whole wall',
    createRailing: 'Create railing',
    updateMezzanine: 'Change mezzanine',
    createOffice: 'Create office building',
    updateOffice: 'Change office building',
    openWallFloor: 'Open exterior wall on one floor',
    closeWallFloor: 'Close exterior wall on one floor',
    setStoreyOutline: 'Draw floor outline',
    resetStoreyOutline: 'Reset floor outline',
    updateFloors: 'Change floors',
    updateFloorHeight: 'Change floor height',
    drawWall: 'Draw wall',
    moveWall: 'Move wall',
    updateWall: 'Change wall',
    rotateWall: 'Rotate wall',
    wallLength: 'Change wall length',
    createRoom: 'Create room',
    updateRoom: 'Change room',
    moveRoom: 'Move room',
    resizeRoom: 'Change room size',
    recalcRoomWalls: 'Recalculate room walls',
    roomLayout: 'Insert room layout',
    createZone: 'Create zone',
    updateZone: 'Change zone',
    moveZone: 'Move zone',
    resizeZone: 'Change zone size',
    insertOpening: 'Insert {type}',
    insertDoubleDock: 'Insert double loading dock',
    changeOpeningType: 'Change opening type',
    updateOpening: 'Change opening',
    moveOpening: 'Move opening',
    openingWidth: 'Change opening width',
    openingLevel: 'Change floor of the opening',
    updateDock: 'Change loading dock',
    saveMeasurement: 'Save dimension',
    updateMeasurement: 'Change dimension',
    moveMeasurement: 'Move dimension',
    insertObject: 'Insert {name}',
    updateObject: 'Change object',
    moveObject: 'Move object',
    moveObjects: 'Move objects',
    hideObjects: 'Hide objects',
    showObjects: 'Show objects',
    placeElement: 'Place {type}',
    extendRoad: 'Extend road',
    extendFence: 'Extend fence',
    liftObject: 'Raise object',
    rotateObject: 'Rotate object',
    duplicateObject: 'Duplicate object',
    duplicateRoofElements: 'Duplicate roof element',
    createColumn: 'Place column',
    updateColumn: 'Change column',
    moveColumn: 'Move column',
    detachColumns: 'Edit columns one by one',
    restoreColumns: 'Restore automatic columns',
    resizeObject: 'Change size',
    objectSize: 'Change object size',
    updateClearance: 'Change clearance',
    changeLevel: 'Change floor',
    updateColor: 'Change colour',
    restoreSize: 'Restore original size',
    insertStair: 'Insert stairs',
    insertStairWithDoor: 'Insert stairs with landing and door',
    updateStair: 'Change stairs',
    moveStair: 'Move stairs',
    rotateStair: 'Rotate stairs',
    updateLanding: 'Change landing',
    createOutdoor: 'Create {type}',
    createFence: 'Create fence',
    movePoint: 'Move point',
    insertPoint: 'Insert point',
    deletePoint: 'Delete point',
    moveSitePoint: 'Move site point',
    insertSitePoint: 'Insert site point',
    deleteSitePoint: 'Delete site point',
    moveZonePoint: 'Move zone point',
    insertZonePoint: 'Insert zone point',
    deleteZonePoint: 'Delete zone point',
    edgeLength: 'Change edge length',
    roadKind: 'Change road type',
    roadWidth: 'Change road width',
    moveRoad: 'Move road',
    resizeRoad: 'Road: change size',
    fenceHeight: 'Change fence height',
    fenceStyle: 'Change fence',
    addGate: 'Insert sliding gate',
    addFenceDoor: 'Insert pedestrian door',
    moveGate: 'Move sliding gate',
    updateGate: 'Change sliding gate',
    removeGate: 'Remove sliding gate',
    moveFence: 'Move fence',
    resizeFence: 'Fence: change size',
    updateParking: 'Change car park',
    moveParking: 'Move car park',
    rotateParking: 'Rotate car park',
    resizeParking: 'Change car park size',
    updateRoofElement: 'Change roof element',
    moveRoofElement: 'Move roof element',
    removeRoofElements: 'Remove roof elements',
    createSite: 'Create site',
    replaceSite: 'Replace site',
    takeOverSites: 'Take over site and background',
    attachSite: 'Attach site',
    rotateSite: 'Rotate site',
    updateSite: 'Change site',
    renameSite: 'Rename site',
    moveSite: 'Move site',
    siteShape: 'Change site shape',
    updateBackground: 'Change background image',
    insertBackground: 'Insert background image',
    removeBackground: 'Remove background image',
    calibrateBackground: 'Set background image scale',
    rotateBackground: 'Rotate background image',
    lockBackground: 'Lock background image',
    unlockBackground: 'Unlock background image',
    alignBackground: 'Align background image',
    moveBackground: 'Move background image',
  },
  defaults: {
    hall: 'Hall {n}',
    office: 'Office building {n}',
    site: 'Site',
    siteNumbered: 'Site {n}',
    room: 'Room {n}',
    fence: 'Fence',
    gate: 'Sliding gate',
    fenceDoor: 'Pedestrian door',
    siteFence: 'Site fence',
    copy: '{name} (copy)',
    officeRoom: 'Office {n}',
    changingWomen: 'Changing room women',
    changingMen: 'Changing room men',
  },
  parse: {
    notObject: 'The project file is not an object',
    missingVersion: 'schemaVersion is missing or invalid',
    tooNew: 'The project was created with a newer version (schema {version}, supported {target})',
    missingMigration: 'No migration from schema {version}',
    invalidData: 'The project data are invalid',
    invalidJson: 'The file is not valid JSON',
  },
  issues: {
    idMismatch: 'ID does not match the key',
    idDuplicate: 'ID is not unique',
    siteBoundary: 'Site boundary is not a valid polygon',
    wallTooThick: 'Wall thickness is too large for the hall dimensions',
    hallOutline: 'The building outline must not cross itself and needs at least 4 m²',
    hallOutlineRoof: 'Freely drawn halls have a flat or mono-pitch roof only',
    mezzanineNoHall: 'Mezzanine without its hall',
    columnNoBuilding: 'Column without its hall or storey',
    mezzaninePolygon: 'Invalid mezzanine outline',
    mezzanineHeight: 'Mezzanine height does not fit into the hall',
    canopyWall: 'Canopy without its wall',
    wallImageWall: 'Wall picture without its wall',
    canopyPastEnd: 'Canopy extends past the end of the wall',
    railingRoof: 'Roof railing without its building',
    officeData: 'Floor data do not match the building type',
    officeHeight: 'Building height does not match the floors',
    stairNoOffice: 'Stairs do not belong to any office building',
    noUpperLevel: 'There is no further floor above this one',
    roofElementNoHall: 'Roof element does not belong to any hall',
    roofElementOutside: 'Roof element extends beyond the roof',
    duplicatePoints: 'Two consecutive points are identical',
    wallLength: 'Wall length must be greater than 0',
    wallOwner: 'Wall refers to an unknown hall or room',
    openingWall: 'Opening refers to a wall that does not exist',
    openingPastEnd: 'Opening extends beyond the end of the wall',
    openingTooHigh: 'Opening is higher than the wall',
    openingsOverlap: 'Openings in the same wall overlap',
    unknownHall: 'Reference to an unknown hall',
    zonePolygon: 'Invalid zone polygon',
    roomPolygon: 'Invalid room polygon',
  },
};
